import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css'
import './styles/smooth.css'
import App from './App.jsx'
import { initializeSecurity } from './config/security'
import BASE_URL from './config/api'

// Set API base URL in localStorage if not set
if (!localStorage.getItem('apiBaseUrl')) {
  localStorage.setItem('apiBaseUrl', BASE_URL);
}

// Initialize security measures
initializeSecurity();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
